/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { EnumSmallNewsCardMax, NewsCardsSectionFragment } from "@cosmos/hygraph-schema";
import { ResponsiveContainer, SectionContainer, SectionHeading, BackgroundContainer } from "@components/elements";
import { VStack } from "@panda/jsx";
import { NewsCards } from "./NewsCards.organism";
import { NewsCardProps } from "./NewsCard.molecule";

export interface NewsCardsSectionProps extends Omit<NewsCardsSectionFragment, "__typename" | "id"> {
	sectionIndex?: number;
	maxCards?: number;
	hideCategoryPills?: boolean;
}

export const NewsCardsSection = ({
	config,
	sectionIndex,
	cards = [],
	maxCards,
	maxCount,
	hideCategoryPills,
}: NewsCardsSectionProps): React.JSX.Element | null => {
	const isFirstSection = sectionIndex === 0;
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(cards?.length);
	if (!validHeading && !validContent) return null;

	const effectiveMaxCards = maxCards ?? (maxCount === EnumSmallNewsCardMax?.Four ? 4 : 2);

	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer
					disablePaddingBlockStart={isFirstSection}
					disablePaddingBlockEnd={!!config?.disablePaddingBottom}
				>
					<VStack gap="eds.dimension.24" alignItems="stretch" className="news-cards-section">
						{validHeading ? <SectionHeading {...config?.heading} compressedTitle /> : null}
						{validContent ? (
							<NewsCards
								cards={cards as NewsCardProps[]}
								maxCards={effectiveMaxCards}
								hideCategoryPills={hideCategoryPills}
							/>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
